module.exports = __webpack_public_path__ + "static/media/right-arrow-default.c974a2a4.svg";